<template>
  <div class="aside">
    <aside-title />
    <aside-content />
  </div>
</template>
<script>
import asideTitle from './aside-title'
import asideContent from './aside-content'
export default {
  name: 'layoutAside',
  components: {
    asideTitle,
    asideContent
  }
}
</script>
<style lang="scss" scoped>
  .aside {
    // display: flex;
    // flex-direction: column;
    width: 200px;
    height: 100%;
    background-color: #545C64;
    flex: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/aside/index.vue